
<script>
import { mapState } from "vuex"

export default {
  props: { ativar: Boolean },
  computed: { 
    ...mapState({
      user: state => state.moduleLogin.user,
      usuario: state => state.moduleLogin.usuario,
      email: state => state.moduleEmail.email,
    }),
  },
  methods: {
    btnSalvarNovo() {
      this.$store.dispatch("CADASTRAREMAIL", {
          usuario: this.usuario.codUsuario,
          cidade: this.user.cidade,
          email: this.email
      }).then((result) => {
        if(result){
          this.$swal.fire({
            title: "Gravar Email",
            text: 'Gravado com Sucesso',
            icon: "success"
          })
          this.$emit('limparCampos')
        }
        else{
          this.$swal.fire({
            title: "Gravar Email",
            text: 'Erro na Tentativa de gravar o email',
            icon: "error"
          })
        }
        }
      )
    },
  }
}
</script>

<template>
  <b-button :disabled='!email.placaValido && !email.placaCompleta' @click='btnSalvarNovo' :variant="!ativar ? 'success' : ''">Salvar</b-button>
</template>

<style>

</style>